import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/fees-structure';
const backUrl='/department'+Url;
const courseUrl='/getallcourse';
const courseYearUrl='/getallcourse-year';
const courseSemesterUrl='/getallcourse-semester';
 
class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            fees_structure_name:'', 
            course_id:'',
            course_year_id:'',
            courseData:[],
            course_sem_id:'',
            courseSemData:[],
            courseYearData:[],
            fg_scholar_amount:0,
            other_scholar_amount:0, 
            feesData:[
                {key:'Tuition Fees',check:false,mq_amount:'',gq_amount:''},
                {key:'Caution Deposit',check:false,mq_amount:'',gq_amount:''},
                {key:'Hostel Fees',check:false,mq_amount:'',gq_amount:''},
                {key:'Other Fees',check:false,data:[{key:'',mq_amount:'',gq_amount:''}]}
            ], 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
        this.getCourseYearData=this.getCourseYearData.bind(this);
    }


    componentDidMount(){
        viewData(courseUrl).then((res)=>{
            if(res.data.status===200){
                let datams =res.data.data;

                this.setState({courseData:datams});
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            let feesDatas=data.feesData;
                            let checklist=['Tuition Fees','Caution Deposit','Hostel Fees'];

                            let check_val=0;
 
                            feesDatas.map((vls,j)=>{
                                if(vls.check_method!=='others'){
                                    let i =checklist.indexOf(vls.fees_head);
                                    this.state.feesData[i]['gq_amount']=vls.gq_amount;
                                    this.state.feesData[i]['mq_amount']=vls.mq_amount;
                                    this.state.feesData[i]['check']=true;
                                    this.setState({feesData:this.state.feesData});
                                }else if(vls.check_method==='others'){  
                                
                                    this.state.feesData[3]['data'].push({key:vls.fees_head,mq_amount:vls.mq_amount,gq_amount:vls.gq_amount});
                                    this.state.feesData[3]['check']=true;
                                    if(check_val===0){
                                        this.state.feesData[3]['data'].splice(0,1); 
                                        check_val=1;
                                    }
                                    this.setState({feesData:this.state.feesData});
                                }
                            });  

                            this.getCourseYearData(data.course_id);
                            this.setState({
                                fees_structure_name:data.fees_structure_name?data.fees_structure_name:'', 
                                course_id:data.course_id?data.course_id:'', 
                                course_year_id:data.course_year_id?data.course_year_id:'', 
                                course_sem_id:data.course_sem_id?data.course_sem_id:'', 
                                fg_scholar_amount:data.fg_scholar_amount?data.fg_scholar_amount:0, 
                                other_scholar_amount:data.other_scholar_amount?data.other_scholar_amount:0, 
                                preloader:false, 
                            },()=>{
                                this.getCourseSemensterData(data.course_id,data.course_year_id);
                            });
                        }
                    });
                }
                        
            }
        });
    }

    getCourseYearData(id){
        viewData(courseYearUrl+'/'+id).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseYearData:datam}); 
            }
        });
    }

    getCourseSemensterData=(id,yearid)=>{
        viewData(courseSemesterUrl+'/'+id+'/'+yearid).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseSemData:datam}); 
            }
        });
    }
 
    setStateFromInput=(event)=> {
        event.preventDefault();
        var obj = {};
        obj[event.target.name] = event.target.value;
        if(event.target.name=='course_id'){
            this.getCourseYearData(event.target.value);
        }
        if(event.target.name=='course_year_id' && event.target.value){
            this.getCourseSemensterData(this.state.course_id,event.target.value);
        }
        this.setState(obj);
    }

    submitForm=()=>{
        if(this.validator.allValid()){
            let { course_year_id, course_id,fees_structure_name,feesData,course_sem_id,fg_scholar_amount, other_scholar_amount} =this.state;
            let params={ course_year_id, course_id,fees_structure_name,feesData,course_sem_id,fg_scholar_amount, other_scholar_amount }; 
            this.setState({ preloader:true});
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    eventHandleCheck=(e,key,i)=>{
        this.state.feesData[i].check=!this.state.feesData[i].check;
        this.setState({feesData:this.state.feesData});
    }
    eventHandleFeeData=(e,key,i,k)=>{
        if(key!=='add' && key!=='delete'){
            if(k!==undefined){
                this.state.feesData[i]['data'][k][key]=e.target.value;
            }else{
                this.state.feesData[i][key]=e.target.value;
            }
        }else{
            if(key==='add'){
                this.state.feesData[i]['data'].push({key:'',mq_amount:'',gq_amount:''});
            }else{
                this.state.feesData[i]['data'].splice(k,1); 
            }
        }
        this.setState({feesData:this.state.feesData});
    }
  
    render() {
        let {title,preloader,fees_structure_name,course_id,courseData,course_year_id,courseYearData,course_sem_id,courseSemData,feesData} = this.state;
        let role=permissionCheck('fees-structure',title);
        if(!role)
            return <Nopermission/>;
        const course_idValid= this.validator.message('Course',course_id, 'required');
        const course_year_idValid= this.validator.message('Course Year',course_year_id, 'required');
        const fees_structure_nameValid= this.validator.message('Fees Structure Name',fees_structure_name, 'required');
        const course_sem_idValid= this.validator.message('Semester Name',course_sem_id, 'required');
      
        let count=1;
        let chl=0;

        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title} Fees Structure</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${fees_structure_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Fees Structure Name<span className="req">*</span></label>
                                    <input type="text" name="fees_structure_name" value={fees_structure_name} onChange={this.setStateFromInput} className={ `md-input ${fees_structure_nameValid ?'md-input-danger':''}`} /> 
                                    {fees_structure_nameValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4">
                                <div className={ `md-input-wrapper ${course_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="course_id" onChange={this.setStateFromInput} value={course_id}>
                                        <option value="">Select Course</option>
                                        {
                                            courseData && courseData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_id} >{val.course_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_idValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4">
                                <div className={ `md-input-wrapper ${course_year_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="course_year_id" onChange={this.setStateFromInput} value={course_year_id}>
                                        <option value="">Select Year</option>
                                        {
                                            courseYearData && courseYearData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_year_id} >{val.year_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_year_idValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${course_sem_id ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className={ `datepicker md-input ${course_sem_idValid ?'md-input-danger':''}`} name="course_sem_id" onChange={this.setStateFromInput} value={course_sem_id}>
                                        <option value="">Select Semester</option>
                                        {
                                            courseSemData && courseSemData.map((val,i)=>{
                                                return(
                                                    <option key={i} value={val.course_sem_id} >{val.semester_name}</option>
                                                );
                                            })
                                        } 
                                    </select> 
                                    {course_sem_idValid} 
                                </div>
                            </div>
                        </div>

                    
                        <div className="uk-grid"> 
                            <div className="uk-width-medium-1-1"> 
                                {
                                    feesData && feesData.map((val,i)=>{
                                        if(val.check){
                                            chl++;
                                        } 
                                        return <span className="md-input-wrapper checkbox-div"  key={i}>
                                            <span className="md-checkbox"  onClick={(e)=>{ 
                                                this.eventHandleCheck(e,'check',i,val.check);
                                            }}> 
                                                <input type="checkbox" className="hide-checkbox" checked={val.check} /> 
                                                <label htmlFor={val.key}>{val.key}</label>
                                            </span> 
                                        </span>;
                                    })
            
                                }
                                {this.validator.message('checkbox', chl, 'required|gt:0',false,{gt: 'Please select atleast one checkbox'} )}
                            </div> 
                        </div>
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-1"> 
                                <table className="uk-table uk-table-nowrap">
                                    <thead className="table-filter fixed-header">
                                        <tr>
                                            <th width="10%" className="uk-text-center">Sno</th>
                                            <th>Fees Head</th>
                                            <th >G.Q Amount</th>
                                            <th >M.Q Amount</th> 
                                        </tr>
                                    </thead>
                                    <tbody  className="fixed-div">
                                        {
                                            feesData && feesData.map((val,i)=>{
                                                if(val.check){
                                                    if(val.key==='Other Fees'){
                                                        let returnArr=[
                                                            <tr key={i+1}>
                                                                <td width="10%" className="uk-text-center"> {count++}</td>
                                                                <th >{val.key} <button onClick={(e)=>{
                                                                    this.eventHandleFeeData(e,'add',i) 
                                                                    ; 
                                                                }}  type="button" className="md-btn md-btn-primary md-btn-mini md-btn-wave-light waves-effect waves-button waves-light">Add</button> </th> 
                                                                <th colSpan="2"></th> 
                                                            </tr>];


                                                        val.data &&  val.data.map((vals,k)=>{
                                                            returnArr.push(
                                                                <tr key={k+8}>
                                                                    <td width="10%" className="uk-text-center"> 
                                                                        { val.data && val.data.length>1 &&
                                                                            <span onClick={(e)=>{ 
                                                                                this.eventHandleFeeData(e,'delete',i,k) ;
                                                                            }} ><i className="material-icons red-text" style={{color:'red'}}>delete</i></span>
                                                                        }
                                        
                                                                    </td>
                                                                    <td  >
                                                                        <div className={ `md-input-wrapper ${vals.key ? 'md-input-filled' : ''}`}>
                                                                            <input type="text" onChange={(e)=>{
                                                                                this.eventHandleFeeData(e,'key',i,k)
                                                                                ; 
                                                                            }}  value={vals.key}  className={ `md-input ${this.validator.message('Fee head', vals.key, 'required') ?'md-input-danger':''}`} /> 
                                                                            <label className="labalFloat" htmlFor="Fees Name">Fees Name<span className="req">*</span></label> 
                                                                            {this.validator.message('Fee head', vals.key, 'required')}
                                                                        </div>
                                                                    </td>
                                                                    <td style={{textAlign:'right'}}>
                                                                        <div className={ `md-input-wrapper ${vals.gq_amount ? 'md-input-filled' : ''}`}>
                                                                            <input type="text" onChange={(e)=>{ 
                                                                                this.eventHandleFeeData(e,'gq_amount',i,k)
                                                                                ; 
                                                                            }}  value={vals.gq_amount} className={ `md-input ${this.validator.message('gq_amount', vals.gq_amount, 'required|decimal') ?'md-input-danger':''}`} />
                                                                            <label className="labalFloat" htmlFor="G.Q Amount">G.Q Amount<span className="req">*</span></label> 
                                                                            {this.validator.message('gq_amount', vals.gq_amount, 'required|decimal')}
                                                                        </div> 
                                                                    </td>  
                                                                    <td  style={{textAlign:'right'}}>
                                                                        <div className={ `md-input-wrapper ${vals.mq_amount ? 'md-input-filled' : ''}`}>  
                                                                            <input type="text" onChange={(e)=>{
                                                                                this.eventHandleFeeData(e,'mq_amount',i,k) ;
                                                                            }}  value={vals.mq_amount} className={ `md-input ${this.validator.message('mq_amount', vals.mq_amount, 'required|decimal') ?'md-input-danger':''}`} />
                                                                            <label className="labalFloat" htmlFor="M.Q Amount">M.Q Amount<span className="req">*</span></label> 
                                                                            {this.validator.message('mq_amount', vals.mq_amount, 'required|decimal')}
                                                                        </div>
                                                                    </td> 
                                                                </tr>);
                                                        });
                                                        return returnArr;
                                
                                                    }else{
                                                        return(
                                                            <tr key={i}>
                                                                <td width="10%" className="uk-text-center"> {count++}</td>
                                                                <td>{val.key} </td>
                                                                <td style={{textAlign:'right'}}>
                                                                    <div className={ `md-input-wrapper ${val.gq_amount ? 'md-input-filled' : ''}`}>
                                                                        <input type="text" onChange={(e)=>{ 
                                                                            this.eventHandleFeeData(e,'gq_amount',i)
                                                                            ;
                                                                        }}  value={val.gq_amount} className={ `md-input ${this.validator.message('gq_amount', val.gq_amount, 'required|decimal') ?'md-input-danger':''}`} />  
                                                                        <label className="labalFloat" htmlFor="G.Q Amount">G.Q Amount<span className="req">*</span></label> 
                                                                        {this.validator.message('gq_amount', val.gq_amount, 'required|decimal')}
                                                                    </div>
                                                                </td>  
                                                                <td style={{textAlign:'right'}}>  
                                                                    <div className={ `md-input-wrapper ${val.mq_amount ? 'md-input-filled' : ''}`}>
                                                                        <input type="text"  onChange={(e)=>{
                                                                            this.eventHandleFeeData(e,'mq_amount',i);
                                                                        }}  value={val.mq_amount} className={ `md-input ${this.validator.message('mq_amount', val.mq_amount, 'required|decimal') ?'md-input-danger':''}`} />
                                                                        <label className="labalFloat" htmlFor="M.Q Amount">M.Q Amount<span className="req">*</span></label> 
                                                                        {this.validator.message('mq_amount', val.mq_amount, 'required|decimal')}
                                                                    </div>
                                                                </td> 
                                                            </tr>);
                                                    }
                                                }
                                            })
                                        }
                                    </tbody> 
                                </table>
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Department/FeesStructure/addEdit.js